
export const contactInfo = {
  phone: "24 995 995",
  email: "kontakt@syddanskmalerfirma.dk",
  address: "Parkgade 67, 6400 Sønderborg",
  cvr: "42297860",
  hours: {
    mon_thu: "07.00 - 16.00",
    fri: "07.00 - 12.30",
    sat_sun: "Lukket"
  },
  facebook: "https://www.facebook.com/profile.php?id=100068966486567"
};

export const menu = [
  { label: "Forside", href: "/" },
  {
    label: "Vores ydelser",
    href: "/vores-ydelser",
    categories: [
      {
        title: "Maling",
        items: [
          { label: "Maling af vægge", href: "/maling-af-vaegge" },
          { label: "Loftmaling", href: "/maling-af-loft" },
          { label: "Maling af træværk", href: "/maling-af-traevaerk" },
          { label: "Maling af vinduer og andet udendørs træværk", href: "/maling-af-vinduer" },
          { label: "Facademaling", href: "/maling-af-facade" }
        ]
      },
      {
        title: "Spartling & tapet",
        items: [
          { label: "Spartling", href: "/spartling" },
          { label: "Opsætning af filt", href: "/opsaetning-af-filt" },
          { label: "Tapetsering", href: "/tapetsering" }
        ]
      },
      {
        title: "Forsikringsskader",
        items: [
          { label: "Hjælp ved forsikringsskader", href: "/forsikringsskader" }
        ]
      },
      {
        title: "Erhverv",
        items: [
          { label: "Malerarbejde for erhverv", href: "/erhvervsmaler" }
        ]
      },
      {
        title: "Ind- og fraflytning",
        items: [
          { label: "Flyttelejligheder", href: "/flyttelejligheder" }
        ]
      },
      {
        title: "Dekorative overflader",
        items: [
          { label: "KC14", href: "/kc14" },
          { label: "Kabric", href: "/kabric" }
        ]
      }
    ]
  },
  { label: "Galleri", href: "/foer-efter" },
  { label: "Kontakt", href: "/kontakt" }
];

export const assets = {
  logo: "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/9a931652-82a1-42a7-bfb8-d6f9d61651ab.png",
  medal: "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/img-6919.jpeg",
  facebookIcon: "https://syddanskmalerfirma.dk/CustomerData/Files/Folders/1-grafik/14_facebook-1.svg",
  gallery: [
    "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/981d9c5b-a176-41a1-b9a8-7ae34c21caa4.jpg",
    "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/440a596c-3866-4a65-98a6-3fd98333fbbc.jpg",
    "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/08761cb8-3aac-4308-b17c-cb43ad338ba7.jpg",
    "https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/f1a527e9-a40b-4c28-8ae1-21b8d0a6137c.jpg"
  ]
};

export const beforeAfterMock = [
  {
    id: "hvid-til-rosa",
    title: { da: "Maling af køkkenvæg (fra hvid til rosa)" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/img-7112.jpeg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/img-7153.jpeg"],
    order: 0
  },
  {
    id: "1",
    title: { da: "Maling af stue og lofter" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/57e44143-c912-49c3-a48b-92e9c69407e7.jpg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/198cb08c-a0db-4a7b-a870-75dadb5a5c82.jpg"],
    order: 1
  },
  {
    id: "2",
    title: { da: "Før og efter maling af entré" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/9275deb4-4eea-4d08-84a3-1666ac7dc3c7.jpg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/ce8e986d-50fe-46b4-859e-c773a461dfee.jpg"],
    order: 2
  },
  {
    id: "3",
    title: { da: "Spartling og maling af væg" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/014023f9-adec-4ac0-97d9-f82cddfa01aa.jpg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/67602c2b-44b5-4915-9591-3adad79bd397.jpg"],
    order: 3
  },
  {
    id: "4",
    title: { da: "Renovering af soveværelse" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/aeae3bb3-5bd3-4118-a71d-58fff91807c0.jpg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/406a0625-e48e-4b88-ac61-7bba2c480588.jpg"],
    order: 4
  },
  {
    id: "5",
    title: { da: "Maling af vinduesparti og døre" },
    before_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/31a4f14e-5688-491d-a013-639cf807b983.jpg"],
    after_image: ["https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/f8a4b090-abb4-43d2-b891-bc72b6392a2a.jpg"],
    order: 5
  }
];


